import type { SearchParameterName } from '../searchParameters';
import { SEARCH_PARAMETER_NAMES } from '../searchParameters';
import { SearchModeEnum } from './searchMode';

// Parameters each mode removes from the full set. `imageurl` is the mirror of
// the others: it only applies to a search-by-image query, so every other mode
// hides it.
const PARAMETERS_HIDDEN_BY_MODE: Record<
  SearchModeEnum,
  readonly SearchParameterName[]
> = {
  [SearchModeEnum.STANDARD]: ['imageurl'],
  [SearchModeEnum.SEARCH_BY_IMAGE]: ['sort', 'mood'],
  [SearchModeEnum.MORE_LIKE_THIS]: [
    'imageurl',
    'sort',
    'mood',
    'events',
    'groupbyevent',
  ],
  [SearchModeEnum.CURATED_SET]: ['imageurl', 'sort', 'mood', 'license'],
  [SearchModeEnum.CONTRIBUTOR]: ['imageurl', 'mood'],
  [SearchModeEnum.ARTIST]: ['imageurl', 'mood', 'groupbyevent'],
  [SearchModeEnum.EVENT]: ['imageurl', 'groupbyevent'],
  [SearchModeEnum.EVENT_ARTIST]: ['imageurl', 'mood', 'groupbyevent'],
  [SearchModeEnum.GROUP_BY_EVENT]: ['imageurl'],
  [SearchModeEnum.STACK]: ['imageurl'],
  [SearchModeEnum.RECENTLY_VIEWED]: ['imageurl'],
};

/**
 * The parameters a mode leaves available: the full set the app understands,
 * minus the ones that mode hides.
 *
 * An allow-list rather than the negation of PARAMETERS_HIDDEN_BY_MODE, so a
 * name the schema does not declare is absent rather than silently available.
 *
 * Kept off the SearchMode value itself. Only the availability rule asks this
 * question, and putting it on the type made every consumer that merely reads
 * `kind` carry a predicate it never calls.
 */
export const availableSearchParametersFor = (
  kind: SearchModeEnum
): readonly SearchParameterName[] => {
  const hidden = PARAMETERS_HIDDEN_BY_MODE[kind];
  return SEARCH_PARAMETER_NAMES.filter((name) => !hidden.includes(name));
};
